module.exports = __webpack_public_path__ + "img/course_music_basis.30671728.png";